// Изучаем XIMA на русском (2026-10-18): основные руководства, переведённые с испанского и английского.

export const RU_GUIDES = [
  {
    slug: "ru",
    lang: "ru",
    nav: "XIMA на русском",
    title: "XIMA: правила, стратегия и руководства на русском",
    description:
      "Всё, чтобы научиться играть в XIMA — кубинскую стратегическую настольную игру в 3D: что это, как играть, официальные правила, доска, режимы, нотация и стратегия.",
    h1: "XIMA на русском",
    intro:
      "XIMA — стратегическая настольная игра, в которую играют «вверх»: доска — это ступенчатая пирамида из четырёх этажей, и побеждает тот, кто первым приведёт свой особый блок на вершину, клетку G7. Эти руководства проведут вас от первой партии до продвинутой стратегии.",
    sections: [
      { h: "С чего начать", links: ["ru/what-is-xima", "ru/how-to-play", "ru/rules", "ru/history-of-xima"] },
      { h: "Правила подробно", links: ["ru/board", "ru/climbing", "ru/capturing", "ru/game-modes", "ru/notation"] },
      { h: "Играть лучше", links: ["ru/strategy", "ru/openings", "ru/cimax"] },
      {
        h: "Играть сейчас",
        p: [
          "В XIMA можно играть бесплатно на juegoxima.com — на компьютере или телефоне, против людей, против бота (четыре уровня сложности), в турнирах или решая ежедневную задачу. Интерфейс игры доступен на русском языке: его можно включить в Настройках.",
        ],
      },
    ],
    es: null,
  },
  {
    slug: "ru/what-is-xima",
    lang: "ru",
    nav: "Что такое XIMA",
    title: "Что такое XIMA? Стратегическая настольная игра в 3D",
    description:
      "XIMA — кубинская настольная игра в 3D: пирамида из 4 этажей, 10 блоков у каждого игрока и одна цель — привести особый блок на вершину. Играйте бесплатно онлайн.",
    h1: "Что такое XIMA?",
    intro:
      "XIMA — стратегическая настольная игра в трёх измерениях. Доска — ступенчатая пирамида из четырёх этажей, а побеждает тот, кто первым приведёт свой особый блок на вершину (клетку G7). Играть можно совсем без случайности, как в шахматы, или с кубиками, как в «Лудо».",
    sections: [
      {
        h: "Доска, на которой играют вверх",
        p: [
          "Сверху доска — это сетка 13 × 13 (169 клеток). Сбоку — пирамида из четырёх этажей с единственной клеткой наверху: вершиной.",
          "Блоки не только перемещаются по доске, но и поднимаются и спускаются. Чтобы подняться, нужна ступенька — другой блок, свой или соперника. Поэтому каждая партия — это гонка: строить пути наверх и перекрывать пути соперника.",
        ],
        figure: "tablero-vista-superior",
      },
      {
        h: "Фигуры: десять одинаковых блоков",
        p: [
          "У каждого игрока 10 блоков своего цвета: девять обычных и один особый. Все ходят одинаково — по прямой в любом из восьми направлений. Победить, дойдя до вершины, может только особый блок.",
          "В начале все блоки находятся вне доски. В свой ход вы либо вводите новый блок на доску, либо передвигаете уже стоящий.",
        ],
      },
      {
        h: "Доминирование и взятие",
        p: [
          "Если блок заканчивает ход на другом блоке, он его доминирует: нижний блок не может ходить, пока накрыт. Если ваш цвет оказывается в большинстве в этой колонне, блоки цвета в меньшинстве взяты и покидают игру.",
        ],
      },
      {
        h: "С кубиками, без кубиков или и то и другое",
        p: [
          "В XIMA четыре режима. «Наука» (Ciencia) — без кубиков. «Случай» (Azar) — с двумя кубиками. В «Сьенсаре» (Cienzar) вы в каждом ходу решаете, ходить свободно или бросать кубики. В «Науке против Случая» (Contrazar) одна сторона играет без кубиков, другая — с кубиками.",
        ],
      },
      {
        h: "Без ничьих",
        p: [
          "В XIMA всегда есть победитель. Если партия заходит в тупик, ничью не предлагают: каждый игрок получает три дополнительных обычных блока, и игра продолжается.",
        ],
      },
    ],
    facts: [
      ["Игроки", "от 2 до 4"],
      ["Доска", "пирамида из 4 этажей, 13 × 13 клеток"],
      ["Фигуры", "10 блоков у игрока: 9 обычных и 1 особый"],
      ["Цель", "привести особый блок на вершину (G7)"],
      ["Режимы", "Наука, Случай, Сьенсар, Наука против Случая"],
      ["Происхождение", "Гавана, Куба, 2010"],
    ],
    faqs: [
      ["Какова цель XIMA?", "Привести свой особый блок на вершину доски, клетку G7, законным ходом. Кто сделает это первым, побеждает."],
      ["Кто придумал XIMA?", "Йосдель Висенте Муиньо Асеведо и Лис Пауэр Суарес в Гаване (Куба) в 2010 году."],
      ["Можно ли играть бесплатно?", "Да, на juegoxima.com — в браузере или на телефоне."],
    ],
    related: ["ru/how-to-play", "ru/rules", "ru/board", "ru/history-of-xima"],
    cta: { label: "Как играть", slug: "ru/how-to-play" },
    es: "que-es-xima",
  },
  {
    slug: "ru/how-to-play",
    lang: "ru",
    nav: "Как играть",
    title: "Как играть в XIMA: руководство для первой партии",
    description:
      "Научитесь играть в XIMA за пять минут: как вводить блоки, ходить по прямой, подниматься по этажам, опираясь на другие блоки, и дойти до вершины.",
    h1: "Как играть в XIMA",
    intro: "Здесь только то, что нужно для первой партии: что нужно сделать, что можно сделать в свой ход и как подняться на вершину.",
    sections: [
      { h: "1. Цель", p: ["Побеждает тот, кто первым приведёт свой особый блок на вершину — клетку G7 на самом верху пирамиды."] },
      {
        h: "2. Ваш ход: ввести или передвинуть",
        p: ["Вы начинаете со всеми 10 блоками вне доски. В каждый ход делаете одно из двух:"],
        list: [
          "Ввести блок: поставить на доску блок, который у вас вне её. Он входит с края пирамиды, двигаясь прямо внутрь или по диагонали, и не может начинать или заканчивать движение на другом блоке.",
          "Передвинуть блок: переместить свой блок, уже стоящий на доске, по прямой (по горизонтали, вертикали или диагонали) на сколько угодно клеток.",
        ],
        figure: "incorporar-bloque",
      },
      {
        h: "3. Как подниматься",
        p: [
          "Каждый этаж пирамиды на две высоты блока выше предыдущего, а блок за один шаг может подняться только на высоту одного блока. Поэтому для перехода на следующий этаж нужна ступенька: блок (свой или соперника) у верхнего этажа, через который можно пройти.",
          "Пример: у вас блоки на A1 и B2. Блок с A1 идёт по диагонали, проходит над B2 и встаёт на C3 — уже второй этаж. B2 послужил ступенькой. Спускаться можно всегда.",
        ],
        figure: "subir-con-escalon",
      },
      {
        h: "4. Доминирование и взятие",
        p: [
          "Если вы заканчиваете ход на блоке, вы его доминируете: он не может ходить, пока накрыт. Если после вашего прихода ни у одного цвета в колонне нет больше блоков, чем у вашего, все цвета, у которых блоков меньше, взяты.",
          "Пример: на красном блоке стоит синий (1 против 1 — красный доминирован, но не взят). Если на эту клетку сверху придёт второй синий, синих 2 против 1 — красный взят.",
        ],
      },
      {
        h: "5. Особый блок",
        p: [
          "Особый блок ходит как остальные, но у него два своих правила: он никогда не может подняться на особый блок соперника или пройти над ним, и только он побеждает на вершине. Если его взяли, вы не проиграли: его можно спасти, приведя на вершину обычный блок.",
        ],
      },
      { h: "6. Первая партия", p: ["Проще всего начать против бота на уровне «Лёгкий» в режиме «Наука» (без кубиков). После партии посмотрите повтор в Истории."] },
    ],
    faqs: [
      ["На сколько клеток может пройти блок?", "В режиме «Наука» — на сколько угодно по прямой. В режиме «Случай» — ровно на столько, сколько выпало на кубике."],
      ["Может ли блок уйти с доски?", "Нет. Блок покидает доску, только если его взяли."],
    ],
    related: ["ru/rules", "ru/climbing", "ru/capturing", "ru/game-modes"],
    cta: { label: "Все правила", slug: "ru/rules" },
    es: "como-jugar",
  },
  {
    slug: "ru/rules",
    lang: "ru",
    nav: "Официальные правила",
    title: "Правила XIMA: 16 официальных правил с пояснениями",
    description:
      "Официальные правила XIMA с примерами: ходы, ввод блоков, движение по прямой, подъём, доминирование, взятие, спасение особого блока и победа.",
    h1: "Правила XIMA",
    intro: "В XIMA 16 официальных правил. Вот они все.",
    sections: [
      { h: "Цель", p: ["Привести свой особый блок на вершину (G7) законным ходом. Кто сделает это первым, побеждает."] },
      {
        h: "Официальные правила",
        list: [
          "В начале у каждого игрока все 10 блоков (9 обычных и 1 особый) находятся вне доски.",
          "Каждый игрок делает один ход за очередь и может вводить или поднимать блок с любой из четырёх граней пирамиды.",
          "В свой ход игрок либо вводит новый блок, либо передвигает один из блоков на доске.",
          "Блоки движутся по прямой в любом направлении (горизонтально, вертикально или по диагонали) на сколько угодно шагов, а в режимах со случаем — на столько, сколько показали кубики.",
          "При вводе блока его первый и последний шаг должны быть на доске: он не может начинать или заканчивать движение на другом блоке.",
          "Попав на доску, блок не может её покинуть.",
          "На каждом шаге блок может подняться на место не выше собственной высоты и может спуститься на любое более низкое место.",
          "Блок, закончивший ход на других блоках, доминирует их: нижние не могут ходить. Кроме того, он убирает блоки других цветов, оказавшиеся в меньшинстве в этой колонне.",
          "Особый блок не может подняться на другой особый блок или пройти над ним.",
          "Если особый блок игрока взят, он может привести обычный блок на вершину, чтобы спасти его, а затем снова ввести особый блок, когда захочет.",
          "Обычный блок не может заканчивать ход на вершине, кроме как для спасения особого блока, но может проходить над клеткой G7.",
          "Игрок, у которого в его ход нет блоков ни на доске, ни вне её, проигрывает (нет ресурсов).",
          "Игрок, у которого в его ход нет блоков вне доски для ввода и все блоки на доске доминированы, побеждает («ахогадо»).",
          "Нельзя в третий раз подряд повторять одну и ту же позицию или последовательность ходов.",
          "Любая ничейная или тупиковая ситуация решается добавлением материала, а не ничьей.",
          "Добавление материала — три дополнительных обычных блока каждому игроку.",
        ],
      },
      {
        h: "Правило высоты",
        p: [
          "Это ключ ко всей игре. Каждый этаж на две высоты блока выше предыдущего, а блок поднимается максимум на одну высоту за шаг. Поэтому нельзя сразу перейти с этажа на этаж: нужно пройти над другим блоком-ступенькой.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Взятие",
        p: [
          "Посчитайте блоки каждого цвета в колонне вместе с только что пришедшим. Если ни у одного цвета нет больше блоков, чем у вашего, все цвета с меньшим числом блоков взяты. Один против одного — только доминирование; два против одного — взятие.",
        ],
        figure: "dominacion-captura",
      },
    ],
    faqs: [
      ["Может ли обычный блок победить?", "Нет. На вершине побеждает только особый блок."],
      ["Может ли партия закончиться вничью?", "Нет. Когда партия заходит в тупик, каждый игрок получает три дополнительных блока."],
    ],
    related: ["ru/board", "ru/climbing", "ru/capturing", "ru/notation"],
    cta: { label: "Доска", slug: "ru/board" },
    es: "reglas",
  },
  {
    slug: "ru/board",
    lang: "ru",
    nav: "Доска",
    title: "Доска XIMA: этажи, клетки и координаты",
    description:
      "Доска XIMA: пирамида из четырёх этажей на 13 × 13 клеток, координаты от A1 до M13, внешние и внутренние кольца, грани, углы и вершина G7.",
    h1: "Доска",
    intro: "Зная этажи пирамиды и названия клеток, вы сможете читать любую партию и планировать путь к вершине.",
    sections: [
      {
        h: "Сверху: 13 × 13 клеток",
        p: [
          "Столбцы обозначаются латинскими буквами от A до M, ряды — числами от 1 до 13. A1 — угол, M13 — противоположный угол, а G7, центр, — вершина.",
        ],
        figure: "tablero-vista-superior",
      },
      {
        h: "Сбоку: четыре этажа",
        table: {
          head: ["Этаж", "Зона (вид сверху)", "Клеток"],
          rows: [
            ["1-й", "Два внешних ряда и столбца", "88"],
            ["2-й", "Квадрат C3–K11 без E5–I9", "56"],
            ["3-й", "Квадрат E5–I9 без вершины", "24"],
            ["4-й (вершина)", "Только G7", "1"],
          ],
        },
        after: ["Каждый этаж на две высоты блока выше предыдущего, поэтому для подъёма всегда нужна ступенька."],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Кольца, грани и углы",
        p: [
          "На каждом этаже, кроме вершины, есть внешнее кольцо (край) и внутреннее (ряд у следующего этажа). На внутренних клетках строят ступеньки.",
          "У пирамиды четыре грани: A1-M1-G7, M1-M13-G7, M13-A13-G7 и A13-A1-G7. Внешние углы — A1, M1, M13 и A13; внутренние — B2, L2, L12 и B12. Верхние диагонали (A1-M13 и M1-A13) — кратчайший путь к вершине, но их и легче всего перекрыть.",
        ],
        figure: "caras-y-casillas",
      },
    ],
    faqs: [["Сколько клеток на доске XIMA?", "169 сверху: 88 на первом этаже, 56 на втором, 24 на третьем и 1 на вершине."]],
    related: ["ru/climbing", "ru/notation", "ru/rules"],
    cta: { label: "Как подниматься", slug: "ru/climbing" },
    es: "reglas/tablero-y-casillas",
  },
  {
    slug: "ru/climbing",
    lang: "ru",
    nav: "Подъём по этажам",
    title: "Как подниматься в XIMA: высоты и ступеньки",
    description:
      "Главное правило XIMA: на сколько блок поднимается за шаг, зачем нужна ступенька для перехода на другой этаж и как подняться сразу на два этажа.",
    h1: "Подъём по этажам",
    intro: "Победа в XIMA — это прежде всего умение подняться раньше соперника. Нужно понять одно правило — правило высоты — и научиться строить ступеньки.",
    sections: [
      {
        h: "Правило высоты",
        p: [
          "За один шаг блок поднимается не выше собственной высоты, то есть может встать на что-то высотой в один блок. Спускаться можно сколько угодно.",
          "Каждый этаж на две высоты блока выше предыдущего, поэтому с первого этажа нельзя сразу шагнуть на второй: нужна опора посередине.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Ступенька",
        p: [
          "Опора — это другой блок на внутренней клетке у верхнего этажа. Поднимающийся блок проходит над ступенькой и в том же ходу оказывается этажом выше.",
          "Пример: блоки на A1 и B2. Блок с A1 идёт по диагонали: над B2 (подъём на одну высоту) и на C3 (ещё одна высота — уже второй этаж). Ступенька может быть своей или чужой.",
        ],
        figure: "subir-con-escalon",
      },
      {
        h: "Сдваивание и двойная ступенька",
        p: [
          "Блок, стоящий на другом блоке, уже имеет нужную высоту: поставив свой блок на свой же, на следующем ходу верхний поднимется без ступеньки. А со ступенькой на первом этаже и ещё одной на втором на одной линии блок поднимется сразу на два этажа: с A1 на E5 по диагонали, над B2 и D4.",
        ],
      },
    ],
    related: ["ru/board", "ru/capturing", "ru/strategy"],
    cta: { label: "Доминирование и взятие", slug: "ru/capturing" },
    es: "reglas/subir-bloques",
  },
  {
    slug: "ru/capturing",
    lang: "ru",
    nav: "Доминирование и взятие",
    title: "Доминирование и взятие в XIMA",
    description:
      "Когда блок в XIMA доминирует другой, когда берёт его, и что такое взятие «сэндвич» и «раздавливание». С понятными примерами.",
    h1: "Доминирование и взятие",
    intro: "В XIMA не нужно брать фигуры соперника, чтобы победить, но доминирование и взятие замедляют его и лишают ступенек.",
    sections: [
      {
        h: "Доминирование",
        p: [
          "Блок доминирует, когда заканчивает ход на одном или нескольких блоках. Все нижние блоки, любого цвета, не могут ходить, пока он стоит сверху. Как только верхний уходит, они снова свободны.",
        ],
      },
      {
        h: "Взятие",
        p: [
          "Когда блок приходит в колонну, считаются блоки каждого цвета вместе с новым. Если ни у одного цвета нет больше блоков, чем у вашего, все цвета с меньшим числом блоков взяты и навсегда покидают игру (кроме особого блока, которого можно спасти).",
        ],
        list: [
          "Синий на красном: 1 против 1. Красный доминирован, но не взят.",
          "Синий приходит на колонну с красным и синим: 2 против 1. Красный взят.",
          "Синий приходит на два красных: 1 против 2. Красные только доминированы.",
        ],
        after: [
          "Учтите высоту: чтобы встать на колонну из двух блоков, нужно прийти сверху — например, спустившись с верхнего этажа. С того же уровня можно подняться только на один блок.",
        ],
        figure: "dominacion-captura",
      },
      {
        h: "Виды взятия",
        list: [
          "«Сэндвич»: ваш блок доминирован соперником, и сверху приходит другой ваш блок — соперник в меньшинстве между двумя вашими.",
          "«Раздавливание»: тот же игрок снова доминирует колонну, ставя второй блок на свой.",
          "Смешанное: оба сразу в одной колонне.",
        ],
      },
    ],
    related: ["ru/rules", "ru/climbing", "ru/strategy"],
    cta: { label: "Стратегия", slug: "ru/strategy" },
    es: "reglas/dominacion-y-captura",
  },
  {
    slug: "ru/game-modes",
    lang: "ru",
    nav: "Режимы игры",
    title: "Режимы XIMA: Наука, Случай, Сьенсар и другие",
    description:
      "Четыре режима XIMA: «Наука» без кубиков, «Случай» с двумя кубиками, «Сьенсар» (выбор в каждом ходу) и «Наука против Случая». Какой выбрать.",
    h1: "Режимы игры",
    intro: "Правила доски одинаковы во всех режимах. Меняется лишь то, кто решает, на сколько шагов вы идёте: вы, кубики или и то и другое.",
    sections: [
      {
        h: "Четыре режима",
        table: {
          head: ["Режим", "Кубики", "Для кого"],
          rows: [
            ["Наука (Ciencia)", "Нет", "Чистая стратегия, как в шахматах."],
            ["Случай (Azar)", "Два в каждом ходу", "Семейные игры и игроки разного уровня."],
            ["Сьенсар (Cienzar)", "Выбор в каждом ходу", "Сочетание расчёта и риска."],
            ["Наука против Случая (Contrazar)", "Только у стороны Случая", "Два стиля друг против друга."],
          ],
        },
      },
      {
        h: "Как работают кубики",
        p: [
          "Каждый кубик — это отдельный ход: блок должен пройти ровно столько шагов по прямой. Оба кубика можно использовать для разных блоков или для одного, меняя направление, в любом порядке. При вводе блока клетка на краю считается первым шагом.",
          "В «Сьенсаре» в начале хода вы либо делаете один свободный ход, как в «Науке», либо бросаете оба кубика и делаете два хода.",
        ],
      },
    ],
    related: ["ru/rules", "ru/how-to-play", "ru/strategy"],
    cta: { label: "Как играть", slug: "ru/how-to-play" },
    es: "modos-de-juego",
  },
  {
    slug: "ru/notation",
    lang: "ru",
    nav: "Нотация",
    title: "Нотация XIMA: как записать партию",
    description:
      "«Очень упрощённая» алгебраическая нотация XIMA: длинная и короткая запись, «-» для ввода блока, «=» для особого блока, взятия и кубики, с примерами.",
    h1: "Нотация",
    intro: "Поскольку все блоки ходят одинаково, записать партию в XIMA проще, чем в шахматах: обычно достаточно указать клетку, куда пришёл блок.",
    sections: [
      {
        h: "Как записывается ход",
        list: [
          "Номер хода с точкой.",
          "Клетка назначения заглавными буквами: D3.",
          "Дефис перед ней, если вводится обычный блок: -C2.",
          "Знак равенства, если вводится особый блок: =C7.",
          "x при взятии: C4xC10.",
          "С кубиками сначала выпавшие числа и косая черта: 4/-A4.",
        ],
      },
      {
        h: "Длинная и короткая запись",
        p: [
          "В длинной записи указываются клетка начала и клетка назначения (C3D3) — так проще новичкам. В короткой — только назначение (D3). Если на клетку могут прийти два блока, добавляют столбец (BD11) или ряд (8C7) начала.",
          "Приход на вершину можно записать как G7, Xima, Cima, (*), 1-0 или Gana. Результат 1-0 значит, что выиграл первый игрок, 0-1 — второй.",
        ],
      },
    ],
    related: ["ru/board", "ru/rules", "ru/openings"],
    cta: { label: "Дебюты", slug: "ru/openings" },
    es: "sistema-de-anotacion",
  },
  {
    slug: "ru/strategy",
    lang: "ru",
    nav: "Стратегия",
    title: "Стратегия XIMA: ключевые идеи, чтобы чаще побеждать",
    description:
      "Стратегия XIMA в одном руководстве: борьба за второй этаж, когда вводить особый блок, два центра, инициатива и как выиграть эндшпиль.",
    h1: "Стратегия",
    intro: "Партия XIMA, как и шахматная, делится на дебют, миттельшпиль и эндшпиль. И всё вращается вокруг одного: подняться раньше соперника.",
    sections: [
      {
        h: "Подняться первым",
        p: [
          "Книга XIMA говорит: больше шансов дойти до вершины у того, кто первым приведёт хотя бы два блока, один из них особый, на третий этаж. А для этого нужно раньше соперника привести хотя бы три блока на второй этаж.",
        ],
      },
      {
        h: "Десять принципов",
        list: [
          "Каждый темп важен: в дебюте два темпа часто стоят больше блока.",
          "Не охотьтесь за блоками в первых ходах.",
          "Готовьте больше одного пути наверх.",
          "Не вводите особый блок рано; вводите его высоко и под защитой, обычно шестым–восьмым.",
          "Оставьте один обычный блок вне доски на эндшпиль.",
          "Доминируйте ступеньки соперника, чтобы остановить его подъём.",
          "Боритесь за средний центр (2-й этаж) и высокий центр (3-й этаж).",
          "Координируйте блоки: разрозненные блоки — плохая позиция.",
          "Сохраняйте инициативу угрозами, требующими ответа.",
          "В эндшпиле помните: два блока сильнее одного.",
        ],
      },
      {
        h: "Эндшпиль и оппозиция",
        p: [
          "Особый блок никогда не может пройти над другим особым блоком, поэтому два особых блока рядом (в оппозиции) перекрывают друг другу линии. В эндшпиле это используют, чтобы поставить поддерживающий обычный блок в «слепую зону», недоступную особому блоку соперника, и подняться на G7.",
        ],
      },
    ],
    related: ["ru/openings", "ru/climbing", "ru/cimax"],
    cta: { label: "Дебюты", slug: "ru/openings" },
    es: "estrategia",
  },
  {
    slug: "ru/openings",
    lang: "ru",
    nav: "Дебюты",
    title: "Дебюты XIMA: первые ходы и их названия",
    description:
      "Дебюты XIMA по книге: почему различных начальных клеток всего 13, и как устроены дебюты Лис, Сюзи, Муиньо, Тану, Паррагенья, Капабланка и Йосдель.",
    h1: "Дебюты",
    intro: "Цель хорошего дебюта — ввести блоки в игру, чтобы отвечать сопернику и как можно скорее подняться.",
    sections: [
      {
        h: "Всего 13 разных дебютов",
        p: [
          "Возможных первых ходов 176: 88 клеток первого этажа, на каждую можно ввести обычный или особый блок. Но четыре грани пирамиды одинаковы и каждая симметрична, так что многие ходы — одна и та же идея. В итоге по-настоящему разных начальных клеток 13.",
        ],
      },
      {
        h: "Дебюты с названиями",
        table: {
          head: ["Дебют", "Клетки", "Идея"],
          rows: [
            ["Йосдель", "A1, M1, M13, A13", "Естественная ступенька на B2 с одним быстрым, но легко перекрываемым путём."],
            ["Капабланка", "A2, B1, L1, M2, M12, L13, B13, A12", "Ступенька на C3 с двумя путями. Пожалуй, самый сбалансированный."],
            ["Паррагенья", "A3, C1, K1, M3, M11, K13, C13, A11", "Две естественные ступеньки (C3 и D3) с пятью путями."],
            ["Тану (украинский)", "A4, D1, J1, M4, M10, J13, D13, A10", "Две естественные ступеньки и одна искусственная, восемь путей; силён в эндшпиле."],
            ["Муиньо", "A5, E1, I1, M5, M9, I13, E13, A9", "Три естественные ступеньки, девять путей; агрессивный контроль 2-го этажа."],
            ["Сюзи", "A6, F1, H1, M6, M8, H13, F13, A8", "Один из самых динамичных дебютов."],
            ["Лис", "A7, G1, M7, G13", "Центральный дебют прямо к вершине; технический и точный."],
          ],
        },
      },
    ],
    related: ["ru/strategy", "ru/notation", "ru/history-of-xima"],
    cta: { label: "Стратегия", slug: "ru/strategy" },
    es: "estrategia/aperturas-xima",
  },
  {
    slug: "ru/cimax",
    lang: "ru",
    nav: "Рейтинг CIMAX",
    title: "CIMAX: рейтинговая система XIMA",
    description:
      "Что такое CIMAX и как он работает: каждый игрок начинает с 1000 очков и получает или теряет их в зависимости от силы, мощности, времени и числа ходов в партии.",
    h1: "Рейтинг CIMAX",
    intro: "CIMAX — рейтинг, измеряющий уровень игрока в XIMA. Он похож на рейтинг Эло в шахматах, но учитывает не только результат, но и то, как вы играли.",
    sections: [
      {
        h: "Основное",
        list: [
          "Каждый игрок начинает с 1000 очков CIMAX.",
          "Для каждого режима — свой CIMAX.",
          "Очки, полученные победителем, вычитаются у проигравшего.",
          "Чем сильнее, быстрее и короче победа, тем больше очков.",
        ],
      },
      {
        h: "Формула",
        p: [
          "Согласно книге XIMA, сила игры (FJ) складывается из стоимости блоков на доске и вне её, взятых блоков и бонуса за победу (16 очков за приход на вершину) или за сдачу соперника. Уровень игры (NJ) — сумма сил обоих игроков. Мощность (PJ) — сила, делённая на 2 в степени эффективного времени (использованное ÷ оговорённое), умноженное на число ходов.",
          "Передаваемый CIMAX = NJ × (большая мощность + 1) ÷ (меньшая мощность + 1) × (CIMAX проигравшего ÷ CIMAX победителя).",
        ],
      },
    ],
    related: ["ru/strategy", "ru/rules"],
    cta: { label: "Стратегия", slug: "ru/strategy" },
    es: "estadisticas/cimax",
  },
  {
    slug: "ru/history-of-xima",
    lang: "ru",
    nav: "История XIMA",
    title: "История XIMA: настольная игра, созданная на Кубе",
    description:
      "XIMA родилась в Гаване в 2010 году. Её создатели — Йосдель Висенте Муиньо Асеведо и Лис Пауэр Суарес. Откуда пришла игра, её название и идея.",
    h1: "История XIMA",
    intro: "XIMA родилась в Гаване (Куба) в 2010 году. Её авторы, Йосдель Висенте Муиньо Асеведо и Лис Пауэр Суарес, хотели создать настольную игру, в которую играют вверх.",
    sections: [
      {
        h: "Обещание любви",
        p: [
          "Как рассказывает книга «Cómo llegar a la Xima», игра началась с обещания: подарить Лис лучшую настольную игру, которая позволила бы больше времени проводить вместе, дома, всей семьёй. На окончательную форму ушло около двенадцати лет.",
        ],
      },
      {
        h: "От шахмат к пирамиде",
        p: [
          "До XIMA Йосдель написал детскую сказку «El rey peón», где оживают шахматные фигуры. Пришлось представить, как могли бы изобрести шахматы, — и возник вопрос, изменивший всё: а что, если доска не плоская? Ответом стала самая загадочная форма — пирамида.",
        ],
      },
      {
        h: "От Cima к Xima",
        p: [
          "Сначала игра называлась Cima — по-испански «вершина», по её цели. Позже название стало XIMA, но самая высокая клетка по-прежнему называется вершиной.",
        ],
      },
    ],
    related: ["ru/what-is-xima", "ru/openings"],
    cta: { label: "Что такое XIMA", slug: "ru/what-is-xima" },
    es: "historia-de-xima",
  },
];
